module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/workshops/workshops.component.less
// module id = ./src/app/routes/workshops/workshops.component.less
// module chunks = main